module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09B2J9FL9.a0803116.jpg";